import React from 'react';
import { inputStyles } from '../shared/FormStyles';
import TextElementForm from '../shared/TextElementForm';

const ProgressBarForm = ({ styles, onUpdate, onBack, formData, onTextChange }) => {
  const handleStyleChange = (property, value) => {
    requestAnimationFrame(() => {
      onUpdate({
        ...styles,
        [property]: value
      });
    });
  };

  return (
    <div className="space-y-6">
      {/* Header with back button */}
      <div className="flex items-center justify-between mb-8 w-full">
        <button
          onClick={onBack}
          className="px-6 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600 
                   transition-colors flex items-center gap-2 text-sm font-medium shadow-sm"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back
        </button>
        <h2 className="text-2xl font-bold text-right">Progress Bar Design</h2>
      </div>

      {/* Progress Bar Styles */}
      <div className="bg-white p-4 rounded-lg border space-y-4">
        <h3 className="font-medium text-gray-900">Bar Appearance</h3>
        <div className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Border Radius
            </label>
            <input
              type="range"
              min="0"
              max="20"
              value={styles.borderRadius}
              onChange={(e) => handleStyleChange('borderRadius', parseInt(e.target.value, 10))}
              className="w-full accent-blue-500"
            />
            <div className="flex justify-between text-sm text-gray-500">
              <span>0px</span>
              <span>{styles.borderRadius}px</span>
              <span>20px</span>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Border Width
            </label>
            <input
              type="range"
              min="0"
              max="5"
              value={styles.borderWidth}
              onChange={(e) => handleStyleChange('borderWidth', parseInt(e.target.value, 10))}
              className="w-full accent-blue-500"
            />
            <div className="flex justify-between text-sm text-gray-500">
              <span>0px</span>
              <span>{styles.borderWidth}px</span>
              <span>5px</span>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Background
              </label>
              <input
                type="color"
                value={styles.backgroundColor}
                onChange={(e) => handleStyleChange('backgroundColor', e.target.value)}
                className={inputStyles.colorInput}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Fill Color
              </label>
              <input
                type="color"
                value={styles.fillColor}
                onChange={(e) => handleStyleChange('fillColor', e.target.value)}
                className={inputStyles.colorInput}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Border Color
              </label>
              <input
                type="color"
                value={styles.borderColor}
                onChange={(e) => handleStyleChange('borderColor', e.target.value)}
                className={inputStyles.colorInput}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Progress Text Styling */}
      <div className="bg-white p-4 rounded-lg border">
        <h3 className="font-medium text-gray-900 mb-4">Progress Text Style</h3>
        <TextElementForm
          textElement={formData.textElements.progressText}
          onElementChange={onTextChange}
          elementKey="progressText"
        />
      </div>
    </div>
  );
};

export default React.memo(ProgressBarForm);
